import ProductRatingStars from "../../../shared/components/ProductRatingStars";
import PropTypes from "prop-types";
import RatingsBreakdownDetail from "./RatingsBreakdownDetail";
import React from "react";

const RatingsOverview = (props) => {
  const {
    averageRatingGeneral,
    averageRatingPrice,
    averageRatingQuality,
    averageRatingStyle,
    count,
    oneStar,
    twoStars,
    threeStars,
    fourStars,
    fiveStars
  } = props;

  if (count <= 0) {
    return null;
  }

  return (
    <div className="ratings-overview">
      <div className="overall">
        <span className="bold">
          Overall
        </span>
        <ProductRatingStars
          averageRating={averageRatingGeneral}
          forGrid={false}
        />
        <span className="styled_h6">
          {`${count} Ratings`}
        </span>
      </div>
      <div className="breakdown">
        <RatingsBreakdownDetail
          starRating={5}
          starRatingCount={fiveStars}
          totalCount={count}
        />
        <RatingsBreakdownDetail
          starRating={4}
          starRatingCount={fourStars}
          totalCount={count}
        />
        <RatingsBreakdownDetail
          starRating={3}
          starRatingCount={threeStars}
          totalCount={count}
        />
        <RatingsBreakdownDetail
          starRating={2}
          starRatingCount={twoStars}
          totalCount={count}
        />
        <RatingsBreakdownDetail
          starRating={1}
          starRatingCount={oneStar}
          totalCount={count}
        />
      </div>
      <div className="rating-by-category">
        <div>
          <span>
            Style
          </span>
          <ProductRatingStars
            averageRating={averageRatingStyle}
            forGrid={false}
          />
        </div>
        <div>
          <span>
            Quality
          </span>
          <ProductRatingStars
            averageRating={averageRatingQuality}
            forGrid={false}
          />
        </div>
        <div>
          <span>
            Price
          </span>
          <ProductRatingStars
            averageRating={averageRatingPrice}
            forGrid={false}
          />
        </div>
      </div>
    </div>
  );
};

RatingsOverview.propTypes = {
  "averageRatingGeneral": PropTypes.number.isRequired,
  "averageRatingPrice": PropTypes.number.isRequired,
  "averageRatingQuality": PropTypes.number.isRequired,
  "averageRatingStyle": PropTypes.number.isRequired,
  "count": PropTypes.number.isRequired,
  /* eslint-disable react/sort-prop-types, sort-keys */
  "oneStar": PropTypes.number.isRequired,
  "twoStars": PropTypes.number.isRequired,
  "threeStars": PropTypes.number.isRequired,
  "fourStars": PropTypes.number.isRequired,
  "fiveStars": PropTypes.number.isRequired
  /* eslint-enable react/sort-prop-types, sort-keys */
};

export default RatingsOverview;
